import { useMemo } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { getCustomerAppointmentsPage } from '../../services/customers';

function useGetCustomerAppointmentsTab({
  customerId,
  businessId,
}: {
  customerId: string;
  businessId: string;
}) {
  const query = useInfiniteQuery({
    queryKey: ['customer-appointments-tab', { customerId, businessId }],
    queryFn: ({ pageParam }) =>
      getCustomerAppointmentsPage({
        customerId,
        businessId,
        cursor: pageParam,
      }),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: lastPage => lastPage.nextCursor ?? undefined,
    enabled: !!customerId && !!businessId,
  });

  const pages = query.data?.pages;
  const appointments = useMemo(
    () => pages?.flatMap(page => page.appointments) ?? [],
    [pages],
  );
  const summary = pages?.[0]?.summary ?? null;

  return {
    appointments,
    summary,
    isInitialLoading: query.isPending,
    isFetching: query.isFetching,
    isFetchingNextPage: query.isFetchingNextPage,
    hasMore: query.hasNextPage,
    loadMore: () => {
      query.fetchNextPage();
    },
    isError: query.isError && !query.data,
    isFetchNextPageError: query.isFetchNextPageError,
    error: query.error,
    refetch: query.refetch,
  };
}

export default useGetCustomerAppointmentsTab;
